// extracted by mini-css-extract-plugin
module.exports = {"capcaleraLite":"capcaleraLite_capcaleraLite__JqUws","titol":"capcaleraLite_titol__0VCKB","fletxa":"capcaleraLite_fletxa__YDnkt"};